.delimiter {
  display: flex;
  align-items: center;
  margin: 10px 0 0;

  &__line {
    height: 0.5px;
    background: #dedee0;
    width: 100%;
  }

  &__text {
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.37px;
    text-transform: uppercase;
    color: #000000;
    display: block;
    padding: 0 22px;
  }
}
